// extracted by mini-css-extract-plugin
module.exports = {"lazyVideo":"eikAoef0","lazyVideo1":"c38PZ8h9","ratioSpan":"jpv4_FV7"};